import { FC } from 'react';
import { AirSelectedItineraryResponseManager, FareList } from 'obt-common';
import { Modal, useModalState } from '@spotnana/blocks/src/Modal';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@spotnana/blocks/src/Typography';
import { IOBTShopFeaturesConfig } from 'obt-common/hooks/useOBTShopFeatures';
import { flex } from '@spotnana/blocks/src/utils';
import { spacings } from '@spotnana/blocks/src/utils/styling/utilityTokens';
import ItineraryLegsSummary from '../ItineraryLegsSummary';
import { modal_secondary_background } from '../shared/styles';
import { fare_container } from './styles';
import { ShareItineraryModalContainer } from '../ShareItineraryModalContainer';

interface FareAddedConfirmationModalProps {
  open: boolean;
  onClose: VoidFunction;
  onViewItineraryList: VoidFunction;
  airSelectedItineraryResponseManager: AirSelectedItineraryResponseManager;
  travelerName: string;
  airSearchResultsFeatures: IOBTShopFeaturesConfig;
  selectedList?: FareList;
}

const FareAddedConfirmationModal: FC<FareAddedConfirmationModalProps> = ({
  open,
  travelerName,
  airSearchResultsFeatures,
  airSelectedItineraryResponseManager,
  onClose,
  onViewItineraryList,
  selectedList,
}) => {
  const { t: tt } = useTranslation('WEB');
  const {
    open: isShareItineraryModalOpen,
    openModal: openShareItineraryModal,
    closeModal: closeShareItineraryModal,
  } = useModalState();
  if (!selectedList) return null;

  const handleShareItinerary = () => {
    onClose();
    openShareItineraryModal();
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      header={{ title: tt('Itinerary successfully saved') }}
      variant="medium"
      footer={{
        primaryAction: {
          onClick: handleShareItinerary,
          text: tt('Share'),
        },
        secondaryAction: {
          onClick: onViewItineraryList,
          text: tt('View Itinerary List'),
        },
      }}
      css={modal_secondary_background}
    >
      <div css={[flex.init, flex.column, spacings.large]}>
        <Trans t={tt}>
          <Typography variant="body1">
            The Itinerary has been saved to <strong>Itinerary for {travelerName}</strong>
          </Typography>
        </Trans>
        <div css={fare_container}>
          <ItineraryLegsSummary
            airSearchResultsFeatures={airSearchResultsFeatures}
            airSelectedItineraryResponseManager={airSelectedItineraryResponseManager}
          />
        </div>
      </div>
      <ShareItineraryModalContainer
        fareList={selectedList}
        onClose={closeShareItineraryModal}
        open={isShareItineraryModalOpen}
      />
    </Modal>
  );
};

export default FareAddedConfirmationModal;
